import styled from 'styled-components'
import { AddToTrolley } from '@sainsburys-tech/bolt'

const { Quantity } = AddToTrolley

export const QuantitySelector = styled(Quantity)`
  margin-bottom: 10px;

  select {
    margin: 0 1px;
    padding: 11px 15px 12px;

    &:hover,
    &:active,
    &:focus {
      border-width: 1px;
      margin: 0 1px;
    }
  }
`
